var domain = process.env.VUE_APP_DOMAIN
var envmode = process.env.VUE_APP_ENV_MODE

var apiList = {
    openOrderItems: domain + '/OpenOrderItems',
    taolijins: domain + '/Taolijins',
    createPddFreeOrders: domain + '/PddTools/createFreeOrders',
    createPddPromotion: domain + '/PddTools/createPddPromotion',
    createPddChannelPromotion: domain + '/PddTools/createPddChannelPromotion',
    createPddRedPacketPromotion: domain + '/PddTools/createRedPacketPromotion',
    createElePromotion: domain + '/EleTools/createElePromotion',
    mediaActivity: domain + '/mp/MpMediaActivities',
    mediaActivityText: domain + '/mp/MpMediaActivityTexts',
    mediaActivityImages: domain + '/mp/MpMediaActivityImages',
    uploadMediaImage: domain + '/mp/MpMediaActivityImages/uploadMediaImage',
    uploadLandingPageFile: domain + '/LandingPages/uploadLandingPageFile',
    uploadPageViewRecordFile: domain + '/PageViewRecords/uploadPageViewRecordFile',
    uploadUserRightsFile: domain + '/UserRightsRecords/uploadUserRightsFile',
    orderSyncRequests: domain + '/OrderSyncRequests',
    isLogin: domain + '/isLogin',
    logout: domain + '/logout',
    withdrawRecords: domain + '/Settings/withdrawRecords',
    userRebateOrders: domain + '/Settings/userRebateOrders',
    userRightsRecords: domain + '/Settings/userRightsRecords',
    withdrawFinish: domain + '/Settings/withdrawFinish',
    withdrawRefuse: domain + '/Settings/withdrawRefuse',
    withdrawReject: domain + '/Settings/withdrawReject',
    withdrawRemark: domain + '/Settings/withdrawRemark',
    withdrawTransfer: domain + '/Settings/withdrawTransfer',
    withdrawTransferRecords: domain + '/Settings/withdrawTransferRecords',
    resendWithdrawTransferNotice: domain + '/Settings/withdrawTransferNotice/resend',
    batchWithdrawFinish: domain + '/Settings/batchWithdrawFinish',
    batchWithdrawTransfer: domain + '/Settings/batchWithdrawTransfer',
    newBonusFinish: domain + '/Settings/newBonusFinish',
    newBonusRefuse: domain + '/Settings/newBonusRefuse',
    newBonusTransfer: domain + '/Settings/newBonusTransfer',
    batchNewBonusFinish: domain + '/Settings/batchNewBonusFinish',
    batchNewBonusTransfer: domain + '/Settings/batchNewBonusTransfer',
    mpAuthConfigs: domain + '/Settings/mp/mpAuthConfigs',
    newBonusSettings: domain + '/Settings/newBonusSettings',
    newBonus: domain + '/Settings/getNewBonus',
    users: domain + '/Settings/Users',
    unionUsers: domain + '/Settings/Users/unionUsers',
    addToBlacklist: domain + '/Settings/Users/addToBlacklist',
    removeFromBlacklist: domain + '/Settings/Users/removeFromBlacklist',
    canAutoWithdraw: domain + '/Settings/Users/canAutoWithdraw',
    notAutoWithdraw: domain + '/Settings/Users/notAutoWithdraw',
    autoWithdrawWhiteList: domain + '/Settings/Users/autoWithdrawWhiteList',
    notAutoWithdrawWhiteList: domain + '/Settings/Users/notAutoWithdrawWhiteList',
    sendServiceChange: domain + '/Settings/Users/sendServiceChange',
    userOrderReport: domain + '/Settings/Users/userOrderReport',
    userReport: domain + '/Settings/Users/userReport',
    rebateLevels: domain + '/Settings/rebateLevels',
    taokeAccountConfigs: domain + '/TaokeAccountConfigs',
    getAccountStatus: domain + '/Settings/accountStatus',
    userProducts: domain + '/UserProducts',
    taobaoAuthConfigs: domain + '/TaobaoAuthConfigs',
    pddAuthConfigs: domain + '/PddAuthConfigs',
    jdAuthConfigs: domain + '/JdAuthConfigs',
    userProductCategories: domain + '/UserProductCategories',
    openProducts: domain + '/OpenProducts/searchOpenProduct',
    reUseMediaImage: domain + '/mp/MpMediaActivities/reUseMediaImage',
    userLevelInfos: domain + '/UserLevelInfos',
    userPoints: domain + '/UserPoints',
    getUsersForSetting: domain + '/UserLevelInfos/getUsersForSetting',
    getUsersForPointSetting: domain + '/UserPoints/getUsersForSetting',
    updateUser: domain + '/Settings/Users',
    updateRebateAgentPid: domain + '/Settings/Users/setPid',
    cancelRebateAgentPid: domain + '/Settings/Users/cancelPid',
    profits: domain + '/ProfitReports',
    taokePid: domain + '/TaokePids',
    getLandingPages: domain + '/LandingPages',
    helpPages: domain + '/HelpPages',
    submitOrder: domain + '/Settings/submitOrder',
    meituanConfigs: domain + '/MeituanConfigs',
    eleConfigs: domain + '/EleConfigs',
    taokeAppKey: domain + '/TaokeAppKeys',
    getFirstOrderCats: domain + '/sdlj/getFirstOrderCats',
    getFirstOrderProducts: domain + '/sdlj/getFirstOrderProducts',
    setOnlyBindUser: domain + '/Settings/Users/setOnlyBindUser',
    unSetOnlyBindUser: domain + '/Settings/Users/unSetOnlyBindUser',
    shopBlackLists: domain + '/ShopBlackLists',
    userBlackLists: domain + '/UserBlackLists',
    rebateSettings: domain + '/Settings/rebateSettings',
    themeConfig: domain + '/Settings/themeConfig',
    updateThemeConfig: domain + '/Settings/updateThemeConfig',
    getRebateSettings: domain + '/Settings/rebateSettings',
    createMeituanPromotion: domain + '/MeituanTools/createMeituanPromotion',
    navSettings: domain + '/Settings/navSettings',
    navCustom: domain + '/Settings/navCustom',
    getDemoNavSettings: domain + '/Settings/getDemoNavSettings',
    activitySettings: domain + '/Settings/activitySettings',
    activityCustom: domain + '/Settings/activityCustom',
    getLayoutSettings: domain + '/Settings/activitySettings',
    getDemoLayoutSettings: domain + '/Settings/getDemoLayoutSettings',
    bannerSettings: domain + '/Settings/bannerSettings',
    bannerCustom: domain + '/Settings/bannerCustom',
    posterSettings: domain + '/Settings/posterSettings',
    posterCustom: domain + '/Settings/posterCustom',
    notBindSettings: domain + '/settings/mp/notBindSettings',
    accountWithdraws: domain + '/AccountWithdrawRecords',
    shopMpConfigs: domain + '/ShowMpConfigs',
    wechatGroups: domain + '/Settings/wechatGroupSettings',
    miniMessageKeywords: domain + '/MiniMessageKeywords',
    jdlijins: domain + '/Jdlijins',
    didiConfigs: domain + '/DidiConfigs',
    batchWithdrawExport: domain + '/Settings/batchWithdrawExport',
    llmConfig: domain + '/LLMConfigs',
    taokeLlmConfigApi: domain + '/TaokeLLMConfigs',
    otherSettings: domain + '/settings/mp/otherSettings'
}

var config = {
    apiList: apiList,
    envmode: envmode,
    domain: domain
}
export {config};
